import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AllowedDomainsService {
    private domains: string[] = [];

    constructor(private http: HttpClient) { }

    loadDomains(): Observable<string[]> {
        return this.http.get<{ domain: string }[]>('/api/email-domains/active').pipe(
            map((res) => res.map((d) => d.domain.toLowerCase())),
            tap((domains) => (this.domains = domains))
        );
    }

    /** Returns the cached list of domains */
    getDomains(): string[] {
        return this.domains;
    }
}
